<script setup lang="ts">
  import { useState } from '~renderer/composables/useState'

  const { gdpr, usp } = useState()
</script>

<template>
  <footer class="bg-tan-900 border-t border-white/5 py-8 text-white">
    <div
      class="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 md:flex-row"
    >
      <div class="flex flex-col items-center gap-2 md:items-start">
        <div class="text-tan-300 flex flex-col items-center gap-2 text-sm md:flex-row">
          <span class="font-display text-xs font-bold tracking-widest text-white uppercase">
            Powered By
          </span>
          <img src="/images/branding/warpworld.png" class="h-4" />
        </div>
        <a href="/privacy" class="text-xs opacity-50">View Our Privacy Policy</a>
        <div id="ncmp-consent-link" class="text-xs opacity-50" v-if="gdpr"></div>
        <span data-ccpa-link="1" class="text-xs opacity-50" v-if="usp"></span>
      </div>
      <div class="flex items-center gap-4 text-lg">
        <a href="https://twitter.com/WarpWorld" class="hover:text-tan-300">
          <i-fa7-brands-twitter />
        </a>
        <a href="https://discord.gg/rKCtJwDSry" class="hover:text-tan-300">
          <i-fa7-brands-discord />
        </a>
        <a href="https://patreon.warp.world/" class="hover:text-tan-300">
          <i-fa7-brands-patreon />
        </a>
      </div>
    </div>
  </footer>
</template>
